import { styled } from "@mui/material/styles";
import { Box, Chip, Typography } from "@mui/material";

export const Container = styled(Box)({
  background: "#ffffff",
  borderRadius: "4px",
  padding: "25px",
  marginTop: "15px",
});

export const Header = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  marginBottom: "24px",
});

export const HeaderLeft = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "24px",
});

export const ImageContainer = styled(Box)({
  width: "200px",
  height: "200px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",
  borderRadius: "4px",
});

export const StatusChip = styled(Box)({
  display: "flex",
});

export const ChipOpen = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#4caf50",
    border: "1px solid #4caf50",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
  },
});

export const ChipClose = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#00000080",
    border: "1px solid #00000080",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    color: "#00000080",
  },
});

export const CompanyNameContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "16px",
  background: "#ffffff",
  borderRadius: "4px",
  height: "64px",
});

export const StyledImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
});

export const CompanyNameTypography = styled(Typography)({
  color: "#000000",
  fontSize: "24px",
  fontWeight: 400,
});
